import { createSvgIcon } from '@mui/material/utils';

const MetricVelocity = createSvgIcon(
  <svg width="28" height="22" viewBox="0 0 28 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.75 14.0835L18.95 8.75035M2.492 20.75C1.35088 18.7231 0.750087 16.4239 0.75 14.0835C0.749913 11.743 1.35054 9.44371 2.4915 7.41676C3.63247 5.38982 5.27357 3.70662 7.24986 2.53636C9.22614 1.3661 11.468 0.75 13.75 0.75C16.032 0.75 18.2739 1.3661 20.2501 2.53636C22.2264 3.70662 23.8675 5.38982 25.0085 7.41676C26.1495 9.44371 26.7501 11.743 26.75 14.0835C26.7499 16.4239 26.1491 18.7231 25.008 20.75" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>,
  'MetricVelocity',
);

export default MetricVelocity;
